import { themeObject } from 'lib';

export const listStyles = {
    container: {
        width: '100%',
        overflow: 'hidden',
    },
    textFieldStyles: {
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    searchIconStyles: {
        color: `${themeObject.palette.primary[400]} !important`,
        width: '24px !important',
        height: '24px !important',
    },
    listContainerStyles: {
        mt: '12px',
        borderRadius: '2px',
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        p: '16px 22px 16px 16px',
        mb: 2,
        height: '369px',
        overflowX: 'hidden',
        overflow: 'auto',
    },
    dataContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        mb: '12px',
    },
    alphabeticalOrderTextStyles: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.medium,
        lineHeight: '21.17px',
        color: themeObject.palette.grayScale[600],
    },
    textStyles: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body2,
        ...themeObject.typography.body.regular,
        lineHeight: '18.52px',
        textWrap: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: themeObject.palette.grayScale[800],
    },
    crossIconStyles: {
        cursor: 'pointer',
        '& .MuiSvgIcon-root': {
            height: '16px',
            width: '16px',
            color: themeObject.palette.grayScale[500],
        },
    },
    emptyContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        pt: 14.1875,
        px: 18.25,
        pb: 22.885,
    },
    errorIconStyles: {
        color: themeObject.palette.tertiary.red[300],
        height: '70px',
        width: '70px',
    },
    errorHeaderTextStyles: {
        ...themeObject.typography.h3,
        lineHeight: '28.18px',
        color: themeObject.palette.primary[700],
        my: 2,
    },
    errorSubHeaderTextStyles: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.regular,
        lineHeight: '21.17px',
        color: themeObject.palette.grayScale[800],
    },
};
